<template>
  <div class="rank-list-container">
    <van-list v-if="list.length > 0" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
      :offset="300">
      <div class="rank-list-item">
        <dl class="rank-item" v-for="(val, index) in list" :key="index" :id="val.id">
          <dt class="rank-item-avatar">
            <div class="rank-item-pos">
              <span class="rank-item-icon" v-if="index < 3"></span>
              <span v-else>{{ index + 1 }}</span>
            </div>
            <img class="rank-item-pic" :src="val.pic" alt :id="val.id" v-if="val.pic" />
          </dt>
          <dd class="rank-item-title" :id="val.id">{{ val.title }}</dd>
          <dd class="rank-item-count" :id="val.id" v-if="showAllTickets()">{{ val.count }}票</dd>
        </dl>
      </div>
    </van-list>
    <Loading v-show="isLoading"></Loading>
  </div>
</template>



<script>
import Loading from "./Loading";
export default {
  name: "RankList",
  props: {},
  data() {
    return {
      list: [],
      apiParams: {
        id: "",
        page: 1,
        size: 10,
        isPreview: 0,
      },
      //
      loading: false,
      finished: false,
      searchValue: "",
      //
      voteButtonText: "投票",
      // 
      isLoading: false,
    };
  },
  components: {
    Loading
  },
  computed: {},
  methods: {
    async onLoad() {
      const orgid = this.$utils.getUrlParams("orgid");
      const { voteInfo, queryConfig, activeTab } = this.$store.state;
      if (this.$utils.getUrlParams("type") == 1) {
        this.apiParams.id = voteInfo.vote_list[activeTab].id;
      } else {
        this.apiParams.id = this.$utils.getUrlParams("id");
      }
      this.apiParams.isPreview =
        this.$utils.getUrlParams("isPreview") || voteInfo.isPreview;
      let response = null;
      if (this.isLoading) return;
      this.isLoading = true;
      if (orgid) {
        // todo 新加密版
        // queryConfig.url =
        //   this.$apis.voteLeaderBoard + "?" + this.$urlKeyValue(this.apiParams);
        queryConfig.url = this.$apis.voteLeaderBoard;
        queryConfig.params = this.apiParams;
        queryConfig.method = "GET";
        response = await this.$fetchApi(queryConfig);
      } else {
        // todo 旧未加密版
        response = await this.$get(this.$apis.voteLeaderBoard, this.apiParams);
      }
      // console.log("排行榜response", response);
      if (response.data.msg === "success") {
        let data = response.data.data.list;
        if (data.length > 0) {
          this.apiParams.page += 1;
          this.list = this.list.concat(data);
        } else {
          this.finished = true;
        }
        this.loading = false;
        this.isLoading = false;
      } else {
        this.$toast.fail(response.data.msg);
      }
    },
    onSearch() { },
    onCancel() {
      // 清空搜索列表
    },
    onFocus() { },
    onBlur() { },
    showAllTickets() {
      if (this.$utils.getUrlParams("id") == 'NTAxOjU1Y2Jh' || this.$utils.getUrlParams("id") == 'NDcxNTphNWEyNQ' ) {
        return false
      }
      return true
    }
  },
  created() {
    this.onLoad();
  },
  watch: {},
};
</script>

<style scoped lang="less">
.rank-list-container {
  min-height: 100%;
  background: #fff;
  padding: .25rem 0 50px 0;

  .van-list {
    .rank-list-item {
      .rank-item {
        height: 1rem;
        padding: 0 0.32rem;
        font-size: 0;
        display: flex;
        margin: 0 0 .25rem 0;

        .rank-item-avatar {
          max-height: 1rem;
          position: relative;
          float: left;

          .rank-item-pos,
          .rank-item-pic {
            display: inline-block;
            vertical-align: middle;
            font-size: 0.36rem;
            color: var(--themeColor);
            margin-right: 0.35rem;
            object-fit: cover;
          }

          .rank-item-pos {
            width: 0.56rem;
            height: 100%;
            text-align: center;
            line-height: 1rem;
          }

          .rank-item-icon {
            display: block;
            width: 100%;
            height: 100%;
          }

          .rank-item-pic {
            width: 1rem;
            height: 1rem;
            border-radius: 50%;
            object-fit: cover;
          }
        }

        .rank-item-title {
          flex: 1;
          text-align: left;
          overflow: hidden;
          display: flex;
          align-items: center;
          font-size: .26rem;
          color: #666;
          height: 1rem;
          // -webkit-line-clamp: 3;
          // text-overflow: ellipsis;
          // -webkit-box-orient: vertical;
          display: -webkit-box;
        }

        .rank-item-count {
          width: 1.5rem;
          text-align: right;
          font-size: 0.34rem;
          color: #666;
          line-height: 1rem;
          text-align: center;
        }
      }

      .rank-item:nth-of-type(1) {
        .rank-item-icon {
          background: url(../assets/images/rank01.png) center center no-repeat;
          background-size: 0.57rem;
        }
      }

      .rank-item:nth-of-type(2) {
        .rank-item-icon {
          background: url(../assets/images/rank02.png) center center no-repeat;
          background-size: 0.57rem;
        }
      }

      .rank-item:nth-of-type(3) {
        .rank-item-icon {
          background: url(../assets/images/rank03.png) center center no-repeat;
          background-size: 0.57rem;
        }
      }
    }
  }
}
</style>